export default __webpack_public_path__ + "static/media/open.03b1f7f5.png";